/**
 * Generate a unique Financial Identification Number (FIN) for encounters
 * Format: FIN-YYYYMMDD-HHMMSS-RRRR
 * Where:
 * - YYYYMMDD: Current date
 * - HHMMSS: Current time
 * - RRRR: Random 4-digit number
 * 
 * @returns {string} A unique FIN number
 */
export const generateFIN = () => {
  const now = new Date();
  const dateStr = now.getFullYear().toString() +
    (now.getMonth() + 1).toString().padStart(2, '0') +
    now.getDate().toString().padStart(2, '0');
  
  const timeStr = now.getHours().toString().padStart(2, '0') +
    now.getMinutes().toString().padStart(2, '0') +
    now.getSeconds().toString().padStart(2, '0');
  
  const randomStr = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  
  return `FIN-${dateStr}-${timeStr}-${randomStr}`;
};

/**
 * Validate if a string is a valid FIN format
 * @param {string} fin - The FIN to validate
 * @returns {boolean} True if valid FIN format
 */
export const isValidFIN = (fin) => {
  if (!fin || typeof fin !== 'string') return false;
  
  // Check if it starts with FIN- and matches the expected format
  const finRegex = /^FIN-\d{8}-\d{6}-\d{4}$/;
  return finRegex.test(fin);
};

/**
 * Extract date from FIN number
 * @param {string} fin - The FIN number
 * @returns {Date|null} Date object or null if invalid
 */
export const getDateFromFIN = (fin) => {
  if (!isValidFIN(fin)) return null;
  
  try {
    const parts = fin.split('-');
    const dateStr = parts[1]; // YYYYMMDD
    const year = parseInt(dateStr.substring(0, 4));
    const month = parseInt(dateStr.substring(4, 6)) - 1; // Month is 0-indexed
    const day = parseInt(dateStr.substring(6, 8));
    
    return new Date(year, month, day);
  } catch (error) {
    return null;
  }
}; 